import { FronteggContext } from '@frontegg/rest-api';
import { axiosAmbient } from 'src/lib/axios';
import {
  listTemplateContextsConfig,
  getTemplateContextConfig,
  createTemplateContextConfig,
  updateTemplateContextConfig,
  deleteTemplateContextConfig,
} from '../lib/templatecontext.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  templateContextListSlice,
  templateContextItemSlice,
  templateContextLoadingSlice,
} from '../slices/templatecontext.slice';

const getHeaders = () => {
  const token = FronteggContext.getAccessToken();
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
    'Headless-Mode': true,
  };
};

export const listTemplateContextsAction = (filters = {}) => {
  return async (dispatch) => {
    dispatch(templateContextLoadingSlice(true));
    try {
      const headers = getHeaders();
      const params = { ...filters };
      const { url } = listTemplateContextsConfig();
      const result = await axiosAmbient.get(url, { headers, params });
      if (result?.status === 200) {
        dispatch(
          templateContextListSlice(result?.data?.template_contexts ?? [])
        );
      }
    } catch (e) {
      showToastError('Failed to load template contexts');
    } finally {
      dispatch(templateContextLoadingSlice(false));
    }
  };
};

export const getTemplateContextAction = (id) => {
  return async (dispatch) => {
    dispatch(templateContextLoadingSlice(true));
    try {
      const headers = getHeaders();
      const { url } = getTemplateContextConfig(id);
      const result = await axiosAmbient.get(url, { headers });
      if (result?.status === 200) {
        dispatch(
          templateContextItemSlice(result?.data?.template_context ?? {})
        );
      }
    } catch (e) {
      showToastError('Failed to load template context');
    } finally {
      dispatch(templateContextLoadingSlice(false));
    }
  };
};

export const createTemplateContextAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch(templateContextLoadingSlice(true));
    try {
      const headers = getHeaders();
      const { url } = createTemplateContextConfig();
      const result = await axiosAmbient.post(url, payload, { headers });
      if (result?.status === 201) {
        showToastSuccess('Template context created successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to create template context');
    } finally {
      dispatch(templateContextLoadingSlice(false));
    }
  };
};

export const updateTemplateContextAction = (id, payload, successCallback) => {
  return async (dispatch) => {
    dispatch(templateContextLoadingSlice(true));
    try {
      const headers = getHeaders();
      const { url } = updateTemplateContextConfig(id);
      const result = await axiosAmbient.put(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Template context updated successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to update template context');
    } finally {
      dispatch(templateContextLoadingSlice(false));
    }
  };
};

export const deleteTemplateContextAction = (id, successCallback) => {
  return async (dispatch) => {
    dispatch(templateContextLoadingSlice(true));
    try {
      const headers = getHeaders();
      const { url } = deleteTemplateContextConfig(id);
      const result = await axiosAmbient.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Template context deleted successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to delete template context');
    } finally {
      dispatch(templateContextLoadingSlice(false));
    }
  };
};
